module.exports = __webpack_public_path__ + "img/goldregen-2020-001.3fb573eb.jpg";